<template>
    <div class="modal" :id="disputeLetterStore.modalID" tabindex="-1" aria-labelledby="Send Mail Modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <div class="ml-4">
                        <h3>Creditfixrr Mailer</h3>
                        <small v-if="disputeLetterStore.totalLetterSelected > 0">
                            {{ disputeLetterStore.totalLetterLoaded }} out of {{disputeLetterStore.totalLetterSelected}} Letter Loaded.
                        </small>
                    </div>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="closeModal(`#${disputeLetterStore.modalID}`)"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pb-5 px-sm-5 mx-50">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" class="wizard-tab-container">
                            <div class="view-list product-checkout mt-0 row" >
                                <div class="items-checkout col-lg-8">
                                    <div class="card ecommerce-card" v-for="letter in disputeLetterStore.mailables">
                                        <div class="item-img">
                                            <a href="#" target="_self">
                                                <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/icons/pdf.png" :alt="letter.letter_name" />
                                            </a>
                                        </div>
                                        <div class="card-body">
                                            <div class="item-name">
                                                <h6 class="mb-0 b-flex">
                                                    {{ letter.letter_name }}
                                                </h6>
                                                <p class="mb-50">
                                                    <span class="text-primary">To: &nbsp;</span>
                                                    <span class="text-grey">
                                                        {{ letter.credit_bureau_name }}
                                                        <template v-if="letter.address">
                                                            ({{ letter.address }})
                                                        </template>
                                                    </span>
                                                </p>
                                                <p class="mb-50 d-flex justify-content-between">
                                                    <p class="mb-0">
                                                        <span class="text-primary">
                                                            First Page:  &nbsp;
                                                        </span>
                                                        <span>
                                                            1
                                                        </span>
                                                    </p>
                                                    <p class="mb-0">
                                                        <span class="text-primary">
                                                            Additional Pages / Attachments:  &nbsp;
                                                        </span>
                                                        <span>
                                                            {{ disputeLetterStore.getAdditionalPages(letter) }}
                                                        </span>
                                                    </p>
                                                </p>
                                            </div>
                                            <span class="text-success"></span>
                                            <span v-if="disputeLetterStore.defaultMailer == disputeLetterStore.lob" class="item-company">
                                                First Page: $ {{ disputeLetterStore.getFirstPagePrice(letter.extra_service) }}
                                            </span>
                                            <span v-if="disputeLetterStore.defaultMailer == disputeLetterStore.lob" class="item-company">
                                                Additional Page: $ {{ disputeLetterStore.getAdditionalPagesPrice(letter.number_of_pages) }}
                                            </span>
                                            <div class="form-group row">
                                                <label
                                                    for="letter-type"
                                                    class="col-sm-4 col-form-label col-form-label-md align-self-center pr-0 py-0 text-primary"
                                                >
                                                    Letter Type:
                                                </label>
                                                <div class="col-sm-6">
                                                    <select
                                                        class="form-control form-control-sm"
                                                        v-model="letter.extra_service"
                                                    >
                                                        <option
                                                            v-for="(label, value) in disputeLetterStore.letterTypes[disputeLetterStore.defaultMailer]"
                                                            :value="value"
                                                        >{{ label }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div
                                                v-if="
                                                    disputeLetterStore.defaultMailer == disputeLetterStore.switchMail
                                                    &&
                                                    letter.extra_service == disputeLetterStore.firstClass
                                                "
                                                class="form-group row"
                                            >
                                                <label
                                                    for="envelop-size"
                                                    class="col-sm-4 col-form-label col-form-label-md align-self-center pr-0 py-0 text-primary"
                                                >
                                                    Envelope Size:
                                                </label>
                                                <div class="col-sm-6">
                                                    <select
                                                        class="form-control form-control-sm"
                                                        v-model="letter.envelop_size"
                                                    >
                                                        <option
                                                            v-for="(label, value) in disputeLetterStore.envelop"
                                                            :value="value"
                                                        >{{ label }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item-options text-center">
                                            <div class="item-wrapper">
                                                <div class="item-cost">
                                                    <h4 class="item-price text-primary">
                                                        {{ disputeLetterStore.getPrice(letter) }}
                                                    </h4>
                                                    <p class="card-text shipping">
                                                        <span class="badge badge-light-success badge-pill"></span>
                                                    </p>
                                                </div>
                                            </div>
                                            <button type="button" class="btn mt-1 remove-wishlist btn-light" @click="disputeLetterStore.removeLetter(letter.id)">
                                                <vue-feather size="14px" type="x" />
                                                <span>Remove</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="checkout-options col-lg-4">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-center justify-content-between mb-1">
                                                <label class="section-label mb-0 font-weight-bolder text-primary">Price Calculator</label>
                                                <button type="button" class="btn btn-outline-primary btn-sm waves-effect" @click="openModal('#creditfixrr-mailer-tutorial')">Watch Creditfixrr Mailer Tutorial</button>
                                            </div>
                                            <div class="form-group">
                                                <label
                                                    for="global-letter-type"
                                                    class="col-form-label col-form-label-sm font-weight-bolder text-primary"
                                                >
                                                    Letter Type:
                                                </label>
                                                <select
                                                    class="form-control form-control-sm"
                                                    v-model="disputeLetterStore.extraServices"
                                                >
                                                    <option
                                                        v-for="(label, value) in disputeLetterStore.letterTypes[disputeLetterStore.defaultMailer]"
                                                        :value="value"
                                                    >{{ label }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label
                                                    for="print-type"
                                                    class="col-form-label col-form-label-sm font-weight-bolder text-primary"
                                                >
                                                    Double Sided:
                                                </label>
                                                <select
                                                    class="form-control form-control-sm"
                                                    v-model="disputeLetterStore.doubleSided"
                                                >
                                                    <option selected value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label
                                                    for="color"
                                                    class="col-form-label col-form-label-sm font-weight-bolder text-primary"
                                                >
                                                    Color:
                                                </label>
                                                <select
                                                    class="form-control form-control-sm"
                                                    v-model="disputeLetterStore.colored"
                                                >
                                                    <option selected value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </select>
                                            </div>
                                            <hr>
                                            <div class="price-details">
                                                <label class="section-label mb-1 font-weight-bolder text-primary">
                                                    Letter Breakdown
                                                </label>
                                                <ul class="list-unstyled">

                                                    <li class="price-detail">
                                                        <div class="detail-title font-weight-bolder text-primary">
                                                            First Page
                                                        </div>
                                                        <div class="detail-amt discount-amt">
                                                            {{ disputeLetterStore.mailables.length }}
                                                        </div>
                                                    </li>
                                                    <li class="price-detail">
                                                        <div class="detail-title font-weight-bolder text-primary">
                                                            Additional Pages
                                                        </div>
                                                        <div class="detail-amt discount-amt">
                                                            {{ disputeLetterStore.getAdditionalPages() }}
                                                        </div>
                                                    </li>
                                                    <li class="price-detail">
                                                        <div class="detail-title font-weight-bolder text-primary">
                                                            Total Letters
                                                        </div>
                                                        <div class="detail-amt discount-amt">

                                                            {{ disputeLetterStore.mailables.length }}
                                                        </div>
                                                    </li>
                                                </ul>
                                                <hr>
                                                <ul class="list-unstyled">
                                                    <li class="price-detail">
                                                        <div class="detail-title detail-total font-weight-bolder text-primary">
                                                            Total Cost
                                                        </div>
                                                        <div class="detail-amt font-weight-bolder">
                                                            ${{ disputeLetterStore.getTotal() }}
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div class="col-12 d-flex flex-sm-row flex-column mt-2">
                                                    <button
                                                        type="button"
                                                        class="btn btn-primary mb-1 mb-sm-1 mr-0 mr-sm-1 btn-sm waves-effect waves-float waves-light d-flex align-items-center"
                                                        @click.once="sendLobMailer"
                                                        :key="disputeLetterStore.sendLobMailerKey"
                                                    >
                                                        <template v-if="disputeLetterStore.isMailSent == true">
                                                            <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                                                            <span class="sr-only">Loading...</span>
                                                        </template>
                                                        Pay &amp; Mail
                                                    </button>
                                                    <button v-if="userStore.user.permissions && userStore.user.permissions.canTopUp" type="button" class="btn btn-outline-primary mb-1 mb-sm-1 mr-0 mr-sm-1 d-sm-block btn-sm waves-effect" @click="openModal('#top-up-modal')">Top Up</button>
                                                    <button v-if="userStore.user.permissions && userStore.user.permissions.canTopUp" type="button" class="btn btn-outline-primary mb-1 mb-sm-1 mr-0 mr-sm-1 d-sm-block btn-sm waves-effect" @click="openModal('#mail-pricing-modal')">
                                                        {{ localizationStore.translate('mail.pricing.button') }}
                                                    </button>
                                                    <button type="button" class="btn btn-primary mb-1 mb-sm-1 btn-sm waves-effect" @click="closeModal(`#${disputeLetterStore.modalID}`)"> Cancel </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <LoadingScreen/>
    <mail-pricing-modal :id="'mail-pricing-modal'" />
    <video-player :id="'creditfixrr-mailer-tutorial'" :videoData="video"/>
</template>
<script>
import { ref, reactive, watch } from 'vue'
import { round } from 'mathjs'
import { useBusinessStore } from '../../stores/BusinessStore.js'
import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import LoadingScreen from '../dispute_letter/components/LoadingScreen.vue'
import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
import MailPricing from './MailPricing'
import Swal from 'sweetalert2'
import videoPlayer from './videoPlayer.vue'
export default{
    components:{
        LoadingScreen,
        'mail-pricing-modal': MailPricing,
        'video-player': videoPlayer
    },
    props:{
    },
    watch: {
        'disputeLetterStore.extraServices'(service) {
            _.forEach(this.disputeLetterStore.mailables, function(mail) {
                mail.extra_service = service;
            });
        },
        'disputeLetterStore.mailables': {
            handler: function (after, before) {
                const $this = this;
                _.forEach(after, function(mail) {
                    if (mail.extra_service == $this.disputeLetterStore.certifiedMail) {
                        mail.envelop_size = $this.disputeLetterStore.medium;
                    }
                });
            },
            deep: true
        }
    },
    setup(props){
        return {
            businessStore: useBusinessStore(),
            disputeLetterStore: useDisputeLetterStore(),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            closeModal: closeModal,
            openModal: openModal,
            video: reactive({
                type: 1,
                source: 'https://www.youtube.com/embed/QZNXyxKECOQ',
                title: 'Creditfixrr Mailer'
            })
        }
    },
    created(){
    },
    mounted() {
        const $this = this;
        $("#creditfixrr-mailer-tutorial").on('hide.bs.modal', function(){
            $('#creditfixrr-mailer-tutorial iframe').attr('src', $('#creditfixrr-mailer-tutorial iframe').attr('src'));
        });
    },
    methods:{
        // send Mail via lob
        sendLobMailer(){
            const $this = this;
            $this.disputeLetterStore.isMailSent = true;
            if (this.disputeLetterStore.validate()) {
                Swal.fire({
                    // title: 'Are you sure you want to Proceed?',
                    html: `
                        <p class="text-justify">
                            Please be advised that all mail transactions, once completed and confirmed, are final.
                        </p>
                        <p class="text-justify">
                            Before proceeding ensure that you have checked your letters for any mistakes.
                        </p>
                        <h3>Are you sure you want to Proceed?</h3>
                    `,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value == true) {
                        const icon = feather.icons["check-circle"].toSvg({ class: 'mr-50' });
                        const messages = [
                            `
                                <div class="d-flex align-items-center">
                                    <span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> Creating Dispute Letter(s)
                                </div>
                                <div>
                                    Preparing Dispute Letter(s) For Processing
                                </div>
                                <div>
                                    Processing Dispute Letter(s) for Shipping
                                </div>
                            `,
                            `
                                <div class="d-flex align-items-center text-primary">
                                    ${icon}
                                    Creating Dispute Letter(s)
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> Preparing Dispute Letter(s) For Processing
                                </div>
                                <div>
                                    Processing Dispute Letter(s) for Shipping
                                </div>
                            `,
                            `
                                <div class="d-flex align-items-center text-primary">
                                    ${icon}
                                    Creating Dispute Letter(s)
                                </div>
                                <div class="d-flex align-items-center text-primary">
                                    ${icon}
                                    Preparing Dispute Letter(s) For Processing
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> Processing Dispute Letter(s) for Shipping
                                </div>
                            `,
                        ];
                        Swal.fire({
                            title: "Preparing Mail",
                            width: "50%",
                            html: messages[0],
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            willOpen: function (sweetalert) {
                                sweetalert.querySelector('.swal2-html-container')
                                    .classList
                                    .add('d-flex', 'align-items-start', 'mx-auto', 'flex-column', 'w-50');
                                    setTimeout(() => {
                                        sweetalert.querySelector('.swal2-html-container').innerHTML = messages[1];
                                        setTimeout(() => {
                                            sweetalert.querySelector('.swal2-html-container').innerHTML = messages[2];
                                            const route = $this.$router.resolve(
                                                {
                                                    name: 'lob-mailer',
                                                    params: {
                                                        client: $this.$route.params.client,
                                                        team: $this.$route.params.team
                                                    }
                                                }
                                            );
                                            _.forEach($this.disputeLetterStore.mailables, function(mail) {
                                                axios.post(
                                                    route.href,
                                                    {
                                                        mails: [mail],
                                                        double_sided: $this.disputeLetterStore.doubleSided,
                                                        color: $this.disputeLetterStore.colored,
                                                        extra_service: $this.disputeLetterStore.extraServices
                                                    }
                                                )
                                                .then(function (response) {
                                                    $this.disputeLetterStore.sendLobMailerKey++;
                                                    $this.disputeLetterStore.isMailSent = false;
                                                    if(response.data.error == true) {
                                                        toastr.error(response.data.message, 'Error!');
                                                        Swal.close();
                                                        return;
                                                    }
                                                    $this.userStore.user.balance = response.data.data.balance;
                                                    $this.closeModal(`#${$this.disputeLetterStore.modalID}`);
                                                    $this.disputeLetterStore.mailables.length = 0;
                                                    toastr.success(response.data.message, response.data.data.letter_name);
                                                    Swal.fire({
                                                        title: 'Thank You! 😇',
                                                        html: `Your Dispute Letter(s) are being Processed for Delivery. <a id="view-detail" href="#">Go To Mail Center</a>`,
                                                        willOpen: function (sweetalert) {
                                                            sweetalert.querySelector("#view-detail").addEventListener("click", (event) => {
                                                                event.preventDefault();
                                                                $this.viewMailerDetail();
                                                            });
                                                        }
                                                    })
                                                })
                                                .catch(function (error) {
                                                    console.log(error);
                                                });
                                            });
                                        }, Math.random() * 10000);
                                    }, Math.floor(Math.random() * 5000));
                            }
                        });

                    }
                    else {
                        $this.disputeLetterStore.isMailSent = false;
                        $this.disputeLetterStore.sendLobMailerKey++;
                    }
                });

            }
        },
        viewMailerDetail() {
            if (this.$route.params.client) {
                this.businessStore.clientDetailTab = 9;
                Swal.close();
            }
            else {
                Swal.close();
                const route = this.$router.resolve(
                    {
                        name: 'mails-list',
                        params: {
                            client: this.$route.params.client,
                            team: this.$route.params.team,
                        }
                    }
                );
                window.location.href = route.href;
            }
        }
    }
}
</script>
<style>
.checkout-form-wizard[data-v-5e9451fa] .wizard-tab-content {
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
    background: transparent!important;
    padding: 0;
}
.checkout-form-wizard[data-v-5e9451fa] .wizard-tab-content {
    -webkit-box-shadow: none!important;
}
.steps-transparent .wizard-tab-content, [dir=rtl] .steps-transparent .wizard-tab-content {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.steps-transparent .wizard-tab-content {
    box-shadow: 0 4px 25px 0 rgb(34 41 47 / 10%);
    background-color: #fff;
}
.steps-transparent .wizard-tab-content, .steps-transparent .wizard-tab-content {
    -webkit-box-shadow: 0 4px 25px 0 rgb(34 41 47 / 10%);
}
.ecommerce-application .view-list .ecommerce-card {
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
}
.ecommerce-application .ecommerce-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 25px 0 rgb(34 41 47 / 25%);
}
.ecommerce-application .view-list .ecommerce-card .item-img {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
}
.ecommerce-application .items-checkout .ecommerce-card .item-img img {
}
.ecommerce-application .view-list .ecommerce-card .card-body {
    /*border-right: 1px solid rgba(60,60,60,.26);*/
}
.ecommerce-application .view-list .ecommerce-card .card-body {
    padding: 1.5rem 1rem;
}
.ecommerce-application .view-list .ecommerce-card .card-body {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.ecommerce-application .items-checkout .ecommerce-card .item-name {
    -webkit-box-ordinal-group: 1!important;
    -ms-flex-order: 0!important;
    order: 0!important;
}

.ecommerce-application .items-checkout .ecommerce-card .item-company, .ecommerce-application .items-checkout .ecommerce-card .item-rating {
    margin-bottom: 0.4rem!important;
}

.ecommerce-application .view-list .ecommerce-card .item-company {
    margin: 0.3rem 0 0.5rem;
}
.ecommerce-application .view-list .ecommerce-card .item-company {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-weight: 400;
    font-size: .875rem;
}
.ecommerce-application .items-checkout .ecommerce-card .item-company, .ecommerce-application .items-checkout .ecommerce-card .item-rating {
    margin-bottom: 0.4rem!important;
}
.ecommerce-application .items-checkout .ecommerce-card .item-quantity {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.b-form-spinbutton.form-control {
    padding: 0;
}

.b-form-spinbutton.d-inline-flex:not(.flex-column) {
    width: auto;
}
.b-form-spinbutton.form-control {
    padding: 0;
}
.b-form-spinbutton.d-inline-flex:not(.flex-column) {
    width: auto;
}
.b-form-spinbutton {
    text-align: center;
    background-image: none;
    padding: 0;
}
.b-form-spinbutton.form-control .btn-group-sm>.btn, .b-form-spinbutton.form-control .btn-sm {
    padding: 0.25rem 0.5rem;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.b-form-spinbutton output {
    border: 0;
    background-color: transparent;
    margin: 0;
    padding: 0 0.25rem;
}
.b-form-spinbutton.form-control .btn-group-sm>.btn, .b-form-spinbutton.form-control .btn-sm {
    padding: 0.25rem 0.5rem;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.ecommerce-application .items-checkout .ecommerce-card .delivery-date {
    margin-top: 1.2rem;
    margin-bottom: 0.25rem;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    padding: 1rem;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.text-center {
    text-align: center!important;
}
.ecommerce-application .view-list .ecommerce-card .item-options .item-wrapper {
    position: relative;
}
.ecommerce-application .view-list .ecommerce-card .item-options .item-wrapper .item-cost .item-price {
    margin-bottom: 0;
}
.ecommerce-application .view-list .ecommerce-card .item-options .item-wrapper .item-cost .item-price {
    color: #7367f0;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    padding: 1rem !important;
}
.ecommerce-application .view-list .ecommerce-card .item-options {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.text-center {
    text-align: center!important;
}
.ecommerce-application .view-list .ecommerce-card .item-options .shipping {
    margin-top: 0.75rem;
}
.card-text:last-child {
    margin-bottom: 0;
}
.ecommerce-application .items-checkout .ecommerce-card .item-options .btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
    cursor: pointer;
}
.ecommerce-application .checkout-options .price-details .price-title {
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
}
.ecommerce-application .checkout-options .price-details .price-title {
    font-weight: 600;
}
.list-unstyled {
    padding-left: 0;
}
.ecommerce-application .checkout-options .price-details .price-detail {
    margin-bottom: 0.75rem;
}
.ecommerce-application .checkout-options .price-details .price-detail {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.items-checkout .card{
    border: none;
    margin-bottom: 2rem;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
    transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
}
.ecommerce-application .view-list .ecommerce-card {
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
}

.checkout-options .card {
    border: none;
    margin-bottom: 2rem;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
    transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
}

</style>
